import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { packageCurrencyToCurrencyCode } from '../../../conversion-utils';
import { PackageSelectorCustomComponentDirective } from './package-selector-custom.component';
import { AppPrice } from '@vendasta/marketplace-apps';

@Component({
  selector: 'sales-ui-package-revenue-cell',
  template: `
    <div class="revenue">
      <billing-ui-price-display
        [currencyCode]="currencyCode"
        [appPrice]="appPrice"
        [align]="'end'"
      ></billing-ui-price-display>
    </div>
  `,
  styles: [
    `
      .revenue {
        text-align: right;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageRevenueCellComponent extends PackageSelectorCustomComponentDirective implements OnInit {
  appPrice: AppPrice;
  currencyCode: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.currencyCode = packageCurrencyToCurrencyCode(this.element.package.pricing?.currency);
    this.appPrice = this.element.price;
  }
}
